export class SortHelper {
  private _sortStates: Record<string, boolean>[] = [];
  private _cacheKey?: string;

  constructor(initialSortAttribute: string, ascending: boolean, typeOfList: string = undefined) {
    const initialState: Record<string, boolean> = {};
    if (typeOfList) {
      this._cacheKey = `sorting_${typeOfList}`;
      const cacheItem = localStorage.getItem(this._cacheKey);
      if (cacheItem) {
        const { attribute, isAscending }: SortingCacheItem = JSON.parse(cacheItem);
        initialState[attribute] = isAscending;
        this._sortStates.push(initialState);
        return;
      }
    }

    initialState[initialSortAttribute] = ascending;
    this._sortStates.push(initialState);
  }

  public get attr(): string {
    return this._sortStates.length ? Object.keys(this._sortStates[0])[0] : '';
  }

  public get direction(): boolean {
    return this._sortStates.length ? this._sortStates[0][this.attr] : false;
  }

  public get sortDirectionLabel(): 'asc' | 'desc' {
    return this.direction ? 'asc' : 'desc';
  }

  public sortBy(arrayToSort: unknown[], sortAttr: string, index = 0): void {
    if (this._sortStates.length) {
      if (this._sortStates[index] && (this._sortStates[index][sortAttr] === true || this._sortStates[index][sortAttr] === false)) {
        this._sortStates[index][sortAttr] = !this._sortStates[index][sortAttr];
      } else {
        const initialState: Record<string, boolean> = {};
        initialState[sortAttr] = false;
        this._sortStates[index] = initialState;
      }
    } else {
      const initialState: Record<string, boolean> = {};
      initialState[sortAttr] = false;
      this._sortStates.push(initialState);
    }

    if (this._cacheKey) {
      localStorage.setItem(this._cacheKey, JSON.stringify(new SortingCacheItem(sortAttr, Boolean(this._sortStates[index][sortAttr]))));
    }
    this.sortValues(arrayToSort, index);
  }

  public clearCache = (): void => localStorage.removeItem(this._cacheKey);

  public sortValues(arrayToSort: unknown[], index = 0): void {
    const sortAttr = this._sortStates.length
      ? this._sortStates[index] && Object.keys(this._sortStates[index])[0]
      : 'noCurrentSortAttribute';
    const sortDirection = this._sortStates[index] && this._sortStates[index][sortAttr] === true ? 1 : -1;

    arrayToSort.sort((a, b) => {
      const sortValA = this.getSortValue(a[sortAttr]);
      const sortValB = this.getSortValue(b[sortAttr]);
      if (sortValA > sortValB) {
        return 1 * sortDirection;
      }
      if (sortValA < sortValB) {
        return -1 * sortDirection;
      }
      if (sortValA && !sortValB) {
        return 1 * sortDirection;
      }
      if (sortValB && !sortValA) {
        return -1 * sortDirection;
      }
      return 0;
    });
  }

  public getSorterClasses(sorterLocation: 'before' | 'after', attrName: string): Record<string, boolean> {
    const sortBase = `sorter-${sorterLocation}`;
    const sorterClasses: Record<string, boolean> = {};
    sorterClasses[sortBase] = true;
    sorterClasses[`${sortBase}--down`] = typeof this._sortStates[0][attrName] === 'undefined' || this._sortStates[0][attrName] === false;
    sorterClasses[`${sortBase}--active`] = typeof this._sortStates[0][attrName] !== 'undefined';
    return sorterClasses;
  }

  private getSortValue = (rawValue: unknown): unknown => {
    //... so we have check the type explicitly
    if (typeof rawValue === 'function') {
      return rawValue();
    } else if (typeof rawValue === 'string') {
      return rawValue.toLowerCase();
    }

    return rawValue;
  };
}

class SortingCacheItem {
  public attribute: string;
  public isAscending: boolean;

  constructor(attribute: string, isAscending: boolean) {
    this.attribute = attribute;
    this.isAscending = isAscending;
  }
}
